import type { IRegionRepository } from '../repositories/region.repository'
import type { GetRegionsParams, RegionListResult } from '../entities/region.entity'

/**
 * Сервіс регіонів (regions).
 * Делегує виклики репозиторію, відповідні ендпоінту бекенда: GET /regions/
 */
export class RegionService {
  constructor(private readonly regionRepository: IRegionRepository) {}

  /**
   * Отримати список регіонів з пагінацією та фільтрами.
   */
  async getRegions(params?: GetRegionsParams): Promise<RegionListResult> {
    return this.regionRepository.findMany(params)
  }
}
